<template>
  <div class="pill__container">
    <div v-for="(item, index) in selectedItems" class="pill__item" :key="item">
      <p class="pill__text" v-if="item && Object.getOwnPropertyDescriptor(item, 'name')">
        {{ item.name }}
      </p>
      <p class="pill__text" v-else>
        {{ item }}
      </p>
      <ButtonBase @click="handleDeselectClick(item, index, $event)">
        <CrossIcon :iconColor="computedColor" />
      </ButtonBase>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

import { useGlobalStore } from "@/stores/globalStore";

import ButtonBase from "@/components/ui/buttons/ButtonBase.vue";
import CrossIcon from "@/components/icons/Cross.vue";

defineProps({
  selectedItems: { type: Array, required: true },
});

const store = useGlobalStore();
const emit = defineEmits(["deselect-clicked"]);
const computedColor = computed(() => (store.getIsDarkMode ? "white" : "black"));

const handleDeselectClick = (item, index, event) => {
  emit("deselect-clicked", item, index);
};
</script>

<style lang="scss">
.pill {
  $height: 3rem;
  $half-height: calc($height / 2);

  &__container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: $padding-std;
  }

  &__text {
    white-space: nowrap;
  }

  &__item {
    background-color: var(--input-background);
    border-radius: 1rem;
    padding: calc($height / 2);
    padding-right: 0.5rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    height: $height;
    border-radius: $half-height;

    // button overrides
    .button {
      background: var(--input-background);
      border-radius: 50%;
      padding: 5px;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        height: 10px;
        width: 10px;
      }
    }
  }
}
</style>
